import { PaletteOptions } from '@mui/material/styles';

// TODO remove after upsells will be refactored
const colors = {
  black: '#000',
  white: '#fff',

  typography100: '#FBFBFF',
  typography200: '#E0E0E0',
  typography300: '#CDCDCD',
  typography400: '#9B9B9B',
  typography500: '#828282',
  typography600: '#4F4F4F',
  typography700: '#333333',
  typography800: '#201F1F',
  typography900: '#0F0F0F',

  primary100: '#E8E8FC',
  primary200: '#D2D1F9',
  primary300: '#BBBAF6',
  primary400: '#A5A3F3',
  primary500: '#8E8CF0',
  primary600: '#7270C0',
  primary700: '#555490',
  primary800: '#393860',
  primary900: '#1C1C30',

  secondary100: '#B1B1CE',
  secondary200: '#8A8AB5',
  secondary300: '#63639D',
  secondary400: '#505090',
  secondary500: '#3C3C84',
  secondary600: '#282861',
  secondary700: '#24244F',
  secondary800: '#141333',
  secondary900: '#0C0C1A',

  tertiary100: '#F1E1F7',
  tertiary200: '#E4C4F0',
  tertiary300: '#D6A6E8',
  tertiary400: '#C989E1',
  tertiary500: '#BB6BD9',
  tertiary600: '#9656AE',
  tertiary700: '#704082',
  tertiary800: '#4B2B57',
  tertiary900: '#25152B',

  vibrant500: '#4B4F9E',
  vibrant900: '#292367',

  accent: '#555BF6',

  success100: '#D3EADD',
  success200: '#B4E8CA',
  success300: '#6CCF96',
  success400: '#4DAB75',
  success500: '#27AE60',
  success600: '#1A7842',
  success700: '#145A32',
  success800: '#0D3C21',
  success900: '#071E11',

  error100: '#FACFD0',
  error200: '#F49EA1',
  error300: '#EF6E73',
  error400: '#E93D44',
  error500: '#E40D15',
  error600: '#B60A11',
  error700: '#89080D',
  error800: '#5B0508',
  error900: '#2E0304',

  warning100: '#FCEBDB',
  warning200: '#FAD6B7',
  warning300: '#F7C292',
  warning400: '#F5AD6E',
  warning500: '#F2994A',
  warning600: '#C27A3B',
  warning700: '#915C2C',
  warning800: '#613D1E',
  warning900: '#301F0F',

  buttonPrimary: '#572d93',
  buttonTertiary: '#f0f0f0',
  buttonSecondary: '#fff',
  buttonPrimaryOutlinedHover: '#6B3AA20D',
  buttonSecondaryOutlinedHover: '#FFFFFF0D',

  textPrimary: '#2f2e37',
  themeBackground: '#FEFEFE',
  themeBackgroundLight: '#EAEEF7',
  themeBackgroundSemiLight: '#F0F0F0',
  themeBackgroundLightSecondary: '#FFF0F0',
  primaryLeo: '#D4C6E5',
  primarySagitarius: '#E4832D',
  primaryLight: '',
  secondaryDark: '#bdbdbd',
  error: '#EB5757',
  warning: '#F2C94C',
  warningLight: '#FBE69B',
  info: '#6A3AA2',
  infoLight: '#9974F6',
  primaryLink: '#219653',
  mainLink: '#0000EF',
  lunarViolet: '#454895',
  chart500: '#56CCF2',
  dark: '',
  gradients: {
    primary: 'linear-gradient(0deg, #400078 9.74%, #732BFF 87.02%)',
    primaryHover:
      'linear-gradient(167.62deg, #141333 -32.12%, #3639A2 4.19%, #6D4BCD 49.79%, #9D5BE9 81.72%);',
    secondary: 'linear-gradient(180deg, #141333 0%, #202261 70.63%, #3a237a 100%)',
    secondaryLight: 'linear-gradient(90.6deg, #6A4DBC 0.47%, #F2994A 137.94%)',
    background: 'linear-gradient(89.69deg, #975bdd -30.16%, #fc9f33 153.85%)',
    geminiGradient: 'linear-gradient(96deg, #642b73 0%, #c6426e 100%)',
    gradientPinkDropDown: 'linear-gradient(94deg, #6a4dbc 0%, #f2994a 100%)',
    lightActive: '',
    aquarius: 'linear-gradient(91deg, #2633A0 0.47%, #5DA0C6 137.94%)',
  },
};

interface ThemeCustomPalette {
  button: {
    main: string;
    mainHover: string;
    mainPressed: string;
    mainDisabled: string;
    contrastMainText: string;
    option: string;
    optionHover: string;
    optionShadow: string;
    optionPressed: string;
    optionDisabled: string;
    contrastOptionText: string;
    image: string;
    imageHover: string;
    imageShadow: string;
    imagePressed: string;
    imageDisabled: string;
    contrastImageText: string;
    contrastTextButtonText: string;
    secondary: string;
    tertiary: string;
    tertiaryHover: string;
    tertiaryPressed: string;
    tertiaryDisabled: string;
    contrastTertiaryText: string;
  };
  input: {
    main: string;
    mainHover: string;
    mainFocus: string;
    tertiaryDisabled: string;
    mainError: string;
    contrastMainText: string;
  };
  select: {
    mainBackground: string;
    mainActiveItemBackground: string;
  };
  checkbox: {
    border: string;
    borderHover: string;
    checked: string;
  };
  chip: {
    main: string;
    secondary: string;
  };
  contentBlockBackground: {
    main: string;
    secondary: string;
  };
  background: {
    accent: string;
    mainBodyMobile: string;
    mainBodyDesktop: string;
  };
  label: {
    discountMain: string;
    contrastDiscountMainText: string;
  };
  link: {
    color: string;
  };
  header: {
    progressBar: {
      main: string;
      mainFilled: string;
    };
    menu: {
      color: string;
    };
    backButton: {
      color: string;
    };
  };
  progressCircularWithValue: {
    main: string;
    mainFilled: string;
  };
  cardAchievement: {
    border: string;
    mainMobile: string;
    mainDesktop: string;
    accentBodyMobile: string;
    accentBodyDesktop: string;
  };
  picker: {
    mainActiveText: string;
    mainInactiveText: string;
    mainBackgroundAccent: string;

    secondaryActiveText: string;
    secondaryInactiveText: string;
    secondaryBackgroundAccent: string;
    mainShadow: string;
  };
  modal: {
    body: string;
    backdrop: string;
    closeButton: string;
  };
  colors: typeof colors;
  textField: {
    border: string;
    borderHover: string;
    borderFocused: string;
    borderDisabled: string;
  };
  autocomplete: {
    border: string;
  };
}

declare module '@mui/material/styles' {
  interface TypeText {
    main: string;
    tertiary: string;
    accent: string;
  }
  interface TypeBackground {
    accent: string;
    secondary: string;
    mainBodyMobile: string;
    mainBodyDesktop: string;
  }
  interface Palette extends ThemeCustomPalette {
    gradient?: { main: string };
  }
  interface PaletteOptions extends ThemeCustomPalette {
    gradient?: { main: string };
  }
}

export const paletteLight: PaletteOptions = {
  contentBlockBackground: {
    main: '#F7F7F7',
    secondary: '#FFFFFF',
  },
  success: {
    main: '#27AE60',
  },
  text: {
    main: '#0F0F0F',
    primary: '#0F0F0F',
    secondary: '#4F4F4F',
    tertiary: '#9B9B9B',
    accent: '#6435E9',
    disabled: '#CDCDCD',
  },
  textField: {
    border: '#00000026',
    borderHover: '#000000CC',
    borderFocused: '#3B50A2',
    borderDisabled: '#0000000D',
  },
  autocomplete: {
    border: '#00000026',
  },
  button: {
    contrastTextButtonText: '#0F0F0F',
    main: '#2C3F8D',
    mainHover: '#3B50A2',
    mainPressed: '#253581',
    mainDisabled: '#C2C2C2',
    contrastMainText: '#FAFAFA',
    option: '#FFFFFF',
    optionHover: '#323995',
    optionShadow: '0px 2px 5px 0px rgba(0, 0, 0, 0.10)',
    optionPressed: '#E8EAF7',
    optionDisabled: '#C2C2C2',
    contrastOptionText: '#0F0F0F',
    image: '#FFFFFF',
    imageHover: '#323995',
    imageShadow: '0px 2px 5px 0px rgba(0, 0, 0, 0.10)',
    imagePressed: '#E8EAF7',
    imageDisabled: '#C2C2C2',
    contrastImageText: '#0F0F0F',
    secondary: '#0BA5C8',
    tertiary: '#F0F0F0',
    tertiaryHover: '#F0F0F0',
    tertiaryPressed: '#DEDEDE',
    tertiaryDisabled: '#C2C2C2',
    contrastTertiaryText: '#0F0F0F',
  },
  input: {
    main: '#00000026',
    mainHover: '#0000001A',
    mainFocus: '#3B50A2',
    tertiaryDisabled: '#828282',
    mainError: '#E13F3D',
    contrastMainText: '#0F0F0F',
  },
  select: {
    mainBackground: '#FAFAFA',
    mainActiveItemBackground: '#0000001A',
  },
  checkbox: {
    border: '#323995',
    borderHover: '#323995',
    checked: '#323995',
  },
  label: {
    discountMain: '#E13F3D',
    contrastDiscountMainText: '#FAFAFA',
  },
  chip: {
    main: '#F7F7F7',
    secondary: '#FFFFFF',
  },
  background: {
    accent: '#0000001a',
    secondary: '#2C3F8D',
    mainBodyMobile: '#FFFFFF',
    mainBodyDesktop: '#F7F7F7',
  },
  link: {
    color: '#0F0F0F',
  },
  header: {
    progressBar: {
      main: '#0000000D',
      mainFilled: '#323995',
    },
    backButton: {
      color: '#0F0F0F',
    },
    menu: {
      color: '#0F0F0F',
    },
  },
  picker: {
    mainActiveText: '#323995',
    mainInactiveText: '#8181814D',
    mainBackgroundAccent: '#0F0F0F4D',
    secondaryActiveText: '#0F0F0F',
    secondaryInactiveText: '#828282',
    secondaryBackgroundAccent: '#0F0F0F',
    mainShadow: '#fbfbff99',
  },
  progressCircularWithValue: {
    main: '#EDEDED',
    mainFilled: '#6554c7',
  },
  cardAchievement: {
    mainMobile: '#FFFFFF',
    mainDesktop: '#F7F7F7',
    accentBodyMobile: '#FFFFFF',
    accentBodyDesktop: '#FFFFFF',
    border: 'linear-gradient(180deg, rgba(96, 72, 201, 0.5) 0%, #4D6EF7 100%)',
  },
  modal: {
    body: '#FFFFFF',
    backdrop: '#00000001',
    closeButton: '#818181',
  },
  colors,
};

export const paletteDark: PaletteOptions = {
  contentBlockBackground: {
    main: '#131A52',
    secondary: '#18256B',
  },
  success: {
    main: '#27AE60',
  },
  text: {
    main: '#FAFAFA',
    primary: '#FAFAFA',
    secondary: '#E0E0E0',
    tertiary: '#CDCDCD',
    accent: '#C6ADFF',
    disabled: '#CDCDCD',
  },
  autocomplete: {
    border: '#00000026',
  },
  button: {
    contrastTextButtonText: '#FAFAFA',
    main: '#5E66FD',
    mainHover: '#7A81FF',
    mainPressed: '#2F37C7',
    mainDisabled: '#C2C2C2',
    contrastMainText: '#FAFAFA',
    option: '#3E4473',
    optionHover: '#C2C2C2',
    optionShadow: '0px 2px 5px 0px rgba(234, 238, 247, 0)',
    optionPressed: '#323995',
    optionDisabled: '#C2C2C2',
    contrastOptionText: '#FAFAFA',
    image: '#3E4473',
    imageHover: '#C2C2C2',
    imageShadow: '0px 2px 5px 0px rgba(234, 238, 247, 0)',
    imagePressed: '#323995',
    imageDisabled: '#C2C2C2',
    contrastImageText: '#FAFAFA',
    secondary: '#0BA5C8',
    tertiary: '#DEDEDE',
    tertiaryHover: '#DEDEDE',
    tertiaryPressed: '#DEDEDE',
    tertiaryDisabled: '#C2C2C2',
    contrastTertiaryText: '#0F0F0F',
  },
  input: {
    main: '#EAEEF726',
    mainHover: '#EAEEF7CC',
    mainFocus: '#7A81FF',
    tertiaryDisabled: '#EAEEF70D',
    mainError: '#E13F3D',
    contrastMainText: '#0F0F0F',
  },
  select: {
    mainBackground: '#18256B',
    mainActiveItemBackground: '#EAEEF71A',
  },
  checkbox: {
    border: '#FFFFFF',
    borderHover: '#FFFFFF',
    checked: '#FFFFFF',
  },
  label: {
    discountMain: '#E13F3D',
    contrastDiscountMainText: '#FAFAFA',
  },
  chip: {
    main: '#131A52',
    secondary: '#18256B',
  },
  background: {
    accent: '#EAEEF71A',
    secondary: '#5E66FD',
    mainBodyMobile: '#18256B',
    mainBodyDesktop: '#131A52',
  },
  link: {
    color: '#FAFAFA',
  },
  header: {
    progressBar: {
      main: '#EAEEF726',
      mainFilled: '#5E66FD',
    },
    menu: {
      color: '#FAFAFA',
    },
    backButton: {
      color: '#FAFAFA',
    },
  },
  progressCircularWithValue: {
    main: '#eaeef70d',
    mainFilled: '#3D24D4',
  },
  cardAchievement: {
    mainMobile: '#18256B',
    mainDesktop: '#131A52',
    accentBodyMobile: '#18256B',
    accentBodyDesktop: '#18256B',
    border: 'linear-gradient(180deg, rgba(96, 72, 201, 0.5) 0%, #4D6EF7 100%)',
  },
  picker: {
    mainActiveText: '#FAFAFA',
    mainInactiveText: '#C2C2C240',
    mainBackgroundAccent: '#FFFFFF40',
    secondaryActiveText: '#FAFAFA',
    secondaryInactiveText: '#CDCDCD',
    secondaryBackgroundAccent: '#FAFAFA',
    mainShadow: '#3239951A',
  },
  modal: {
    body: '#18256B',
    backdrop: '#00000001',
    closeButton: '#C2C2C2',
  },
  colors,
  textField: {
    border: '#00000026',
    borderHover: '#000000CC',
    borderFocused: '#3B50A2',
    borderDisabled: '#0000000D',
  },
};
